import { Component, OnInit, OnDestroy } from '@angular/core';
import { ExpenseService } from '../share/services/expense/expense.service';
import { CompanyServiceService } from 'src/app/share/services/company-service/company-service.service';
import { StorageService } from 'src/app/share/services/storage-service/storage.service';
import { StorageKeys } from '../share/enums/storage.enum';
import { NgbModal, NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { RangeDatePickerComponent } from 'src/app/share/range-date-picker/range-date-picker.component';
import dayjs from 'dayjs';
import { ExpenseDetailComponent } from './expense-detail/expense-detail.component';
import {
  faCalendarDays,
  faBuilding,
  faPlus,
  faArrowRight,
  faSearch,
  faTag,
  faCreditCard,
  faSpinner,
  faChevronDown,
  faEye
} from '@fortawesome/free-solid-svg-icons';
import { CommonServiceService } from '../share/services/common-service/common-service.service';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-expenses',
  templateUrl: './expenses.component.html',
  styleUrls: ['./expenses.component.scss'],
  standalone: false
})
export class ExpensesComponent implements OnInit, OnDestroy {
  private readonly searchSubject$ = new Subject<string>();
  private searchSubscription!: Subscription;
  protected readonly faCalendarDays = faCalendarDays;
  protected readonly faBuilding = faBuilding;
  protected readonly faPlus = faPlus;
  protected readonly faArrowRight = faArrowRight;
  protected readonly faSearch = faSearch;
  protected readonly faTag = faTag;
  protected readonly faCreditCard = faCreditCard;
  protected readonly faSpinner = faSpinner;
  protected readonly faChevronDown = faChevronDown;
  protected readonly faEye = faEye;

  loader: boolean = false;
  endOfResult: boolean = false;
  expensesList: any[] = [];
  branches: any[] = [
    { _id: '', name: 'All Branches' }
  ];
  isBranchVisible: boolean = false;
  categoryMap: any = {};
  paymentTypes = [
    { label: 'All Payment Modes', key: '' },
    { label: 'Cash', key: 'Cash' },
    { label: 'UPI', key: 'UPI' },
    { label: 'Bank Transfer', key: 'BankTransfer' },
    { label: 'Card', key: 'Card' },
    { label: 'Bajaj Finance', key: 'BajajFinance' }
  ];

  highlights = {
    total: 0,
    entire: 0,
    topCategory: '',
    avgEntire: 0,
    topCategoryFooter: ''
  };

  categories: any[] = [];
  page: number = 0;
  categoriesObj: any = {page:0}
  filters: any = {
    created_datefrom: '',
    created_dateupto: '',
    company: '',
    category_in: [],
    paymentMode: '',
    description: '',
  };

  constructor(
    private readonly expenseService: ExpenseService,
    private readonly companyService: CompanyServiceService,
    private readonly storageService: StorageService,
    private readonly modalService: NgbModal,
    private readonly offcanvasService: NgbOffcanvas,
    private readonly cmnService: CommonServiceService
  ) { 
    const userDetailsData = this.storageService.getDataFromLocalStorage(StorageKeys.SELF_DETAILS);
    this.isBranchVisible = userDetailsData?.enrollmentType === 'Company';
  }

  ngOnInit(): void {
    const todayStr = dayjs().format('YYYY-MM-DD');
    this.filters.created_datefrom = todayStr;
    this.filters.created_dateupto = todayStr;

    if (this.isBranchVisible) {
      this.getBranchList();
    }
    this.getCategories();
    this.getExpensesList();

    this.searchSubscription = this.searchSubject$.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe((val: string) => {
      this.filters.description = val.trim();
      this.onFilterChange();
    });
  }

  ngOnDestroy(): void {
    if (this.searchSubscription) this.searchSubscription.unsubscribe();
  }

  getBranchList() {
    this.companyService.getToCompanyList().subscribe({
      next: (res: any) => {
        let branches = res.data || [];
        branches = branches?.filter((company: any) => company.status === 'Active') || [];
        this.branches = [...this.branches, ...branches]
      },
    });
  }

  getCategories() {
    this.categoriesObj.loader = true
    this.expenseService.getExpenseCategory({page: this.categoriesObj.page}).subscribe({
      next: (res: any) => {
        let categories = res.data || [];
        this.categories = [...this.categories, ...categories];
        this.categoriesObj.loader = false;
        if(categories?.length == 0) this.categoriesObj.end = true;
      },
      error:() =>{
        this.categoriesObj.loader = false;
      },
    });
  }

  scroolCategories() {
    if(this.categoriesObj?.loader || this.categoriesObj?.end) return;
    this.categoriesObj.page++
    this.getCategories();
  }

  private getFilterParams(): any {
    const params: any = {};
    Object.keys(this.filters).forEach(key => {
      const val = this.filters[key];
      if (val !== '' && val !== null && val !== undefined) {
        if (Array.isArray(val)) {
          if (val.length > 0) {
            params[key] = val.join(',');
          }
        } else {
          params[key] = val;
        }
      }
    });
    return params;
  }

  getExpensesList(append: boolean = false) {
    this.loader = true;
    const filterParams = this.getFilterParams();
    const params: any = {
      ...filterParams,
      page: this.page,
    };
    if (!append) {
      this.getExpenseHighlights(filterParams);
    }
    this.expenseService.getExpenseList(params).subscribe({
      next: (res: any) => {
        const data = res.data || [];
        this.expensesList = params.page == 0 ? data : this.expensesList.concat(data)
        if (data.length === 0) {
          this.endOfResult = true;
        }
        this.loader = false;
      },
      error: (err: any) => {
        this.loader = false;
      }
    });
  }

  getExpenseHighlights(filterParams: any) {
    this.expenseService.getExpanseHighlights(filterParams).subscribe({
      next: (res: any) => {
        const data = res.data || {};
        const topCat = data.topCategory || {};
        this.highlights = {
          total: this.cmnService.parseNumberOrZero(data.totalValue),
          entire: this.cmnService.parseNumberOrZero(data.totalEntries),
          topCategory: topCat?.categoryName || '-',
          avgEntire: this.cmnService.parseNumberOrZero(data.avgPerEntry),
          topCategoryFooter: topCat ? `₹${(topCat.totalValue || 0)?.toLocaleString()} (${topCat.count || 0} entries)` : '-'
        };
      },
      error: (err: any) => {
        this.highlights = {
          total: 0,
          entire: 0,
          topCategory: '-',
          avgEntire: 0,
          topCategoryFooter: '-'
        };
      }
    });
  }

  onFilterChange() {
    this.page = 0;
    this.endOfResult = false;
    this.expensesList = [];
    this.getExpensesList();
  }

  onSearchInput(val: string) {
    this.searchSubject$.next(val);
  }

  onScrollTable() {
    if (this.loader || this.endOfResult) return;
    this.page++;
    this.getExpensesList(true);
  }

  openCalendar() {
    const modalRef = this.modalService.open(RangeDatePickerComponent, { size: 'lg', centered: true });
    modalRef.componentInstance.initialFromDate = this.filters.created_datefrom || null;
    modalRef.componentInstance.initialToDate = this.filters.created_dateupto || null;

    modalRef.result.then((result) => {
      if (result?.fromDate && result?.toDate) {
        this.filters.created_datefrom = result.fromDate;
        this.filters.created_dateupto = result.toDate;
        this.onFilterChange();
      }
    }, () => { });
  }

  openExpenseDetail(expenseData: any = null) {
    const offcanvasRef = this.offcanvasService.open(ExpenseDetailComponent, {
      position: 'end',
      panelClass: 'expense-detail-offcanvas',
      backdrop: 'static',
      keyboard: false
    });

    offcanvasRef.componentInstance.branches = this.branches.filter((b: any) => b._id !== '');
    offcanvasRef.componentInstance.isBranchVisible = this.isBranchVisible;

    if (expenseData) {
      offcanvasRef.componentInstance.mode = 'VIEW';
      offcanvasRef.componentInstance.expenseData = expenseData;
    } else {
      offcanvasRef.componentInstance.mode = 'ADD';
      offcanvasRef.componentInstance.expenseData = null;
    }

    offcanvasRef.result.then((result) => {
      if (result === 'SAVED' || result === 'DELETED') {
        this.onFilterChange();
      }
    }, () => { });
  }

  formatDate(dateStr: string): string {
    if (!dateStr) return '';
    return dayjs(dateStr).format('DD MMM YYYY');
  }

  get selectedDateRangeText(): string {
    const from = this.filters.created_datefrom;
    const to = this.filters.created_dateupto;
    if (!from || !to) return 'Select Date';
    if (from === to) {
      return this.formatDate(from);
    }
    return `${this.formatDate(from)} - ${this.formatDate(to)}`;
  }

  get selectedBranchText(): string {
    if (!this.filters.company) return 'All Branches';
    const branchObj = this.branches.find(b => b._id === this.filters.company);
    return branchObj ? branchObj.name : 'All Branches';
  }

  getGroupDateKey(dateStr: any): string {
    if (!dateStr) return 'unknown';
    const dateVal = new Date(dateStr);
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    });
    return formatter.format(dateVal);
  }

  getGroupDateLabel(dateStr: any): string {
    if (!dateStr) return 'Unknown Date';

    const key = this.getGroupDateKey(dateStr);
    const parsedKolkata = dayjs(key);

    const todayStr = this.getGroupDateKey(new Date());
    const todayKolkata = dayjs(todayStr);

    const diffDays = todayKolkata.diff(parsedKolkata, 'day');

    if (diffDays === 0) {
      return 'Today';
    } else if (diffDays === 1) {
      return 'Yesterday';
    } else if (diffDays === 2) {
      return '2 days ago';
    } else if (diffDays === 3) {
      return '3 days ago';
    } else {
      return dayjs(key).format('DD MMM YYYY');
    }
  }

  get groupedExpenses(): any[] {
    const groups: any[] = [];

    this.expensesList.forEach(item => {
      const dateVal = item.transactionDate;
      const key = this.getGroupDateKey(dateVal);

      let currentGroup = groups.at(-1);
      if (currentGroup?.dateKey !== key) {
        currentGroup = {
          dateLabel: this.getGroupDateLabel(dateVal),
          dateKey: key,
          entriesCount: 0,
          totalAmount: 0,
          items: []
        };
        groups.push(currentGroup);
      }

      currentGroup.items.push(item);
      currentGroup.entriesCount++;
      currentGroup.totalAmount += Number(item.amount || 0);
    });

    return groups;
  }

  getBadgeStyle(category: any) {
    if (category?.color) {
      const bg = category.color + '66';
      const text = category.color;
      return { 'background-color': bg, 'color': text };
    }
    if (typeof category === 'string') {
      const cat = this.categoryMap[category];
      if (cat?.color) {
        return { 'background-color': cat.color + '66', 'color': cat.color };
      }
    }
    return { 'background-color': '#F3F4F6', 'color': '#4B5563' };
  }

}

